import { Button } from "baseui/button"
import { VscTrash } from "react-icons/vsc"
import { IEnergyRate } from "./types";
import { useDeleteObjectMutation, useGetRelationsOutByIdQuery } from "../../../services/objects";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

interface DeleteEnergyRateButtonProps extends IEnergyRate {
    disabled?: boolean;
}
const DeleteEnergyRateButton = (props: DeleteEnergyRateButtonProps) => {
    const [deleteObject, deleteObjectResult] = useDeleteObjectMutation();
    useReportMutationState(deleteObjectResult, () => setIsOpen(false));
    
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (e) => { e.stopPropagation(); e.preventDefault(); setIsOpen(true); }
    const handleCloseClick = (e) => { setIsOpen(false); }
    const handleDeleteClick = (e) => { e.stopPropagation(); e.preventDefault(); deleteObject({ id: props.id, resourceGroupId: props.resourceGroupId }); }

    return (
        <>
            <Button onClick={handleClick} disabled={props.disabled} shape="round" kind="tertiary"><VscTrash></VscTrash></Button>
            {isOpen &&
                <Modal onClose={handleCloseClick} isOpen={isOpen}>
                    <ModalHeader>
                        <FormattedMessage id="DeleteEnergyRateButton.Header" defaultMessage="Delete Energy Rate"></FormattedMessage>
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage id="DeleteEnergyRateButton.Message" defaultMessage="Do you really want to delete {name}?" values={{ name: <b>{props.name}</b> }}></FormattedMessage>
                    </ModalBody>
                    <ModalFooter>
                        <ModalButton kind="tertiary" onClick={handleCloseClick}>
                            <FormattedMessage id="cancel" defaultMessage="Cancel"></FormattedMessage>
                        </ModalButton>
                        <ModalButton onClick={handleDeleteClick} isLoading={deleteObjectResult.isLoading}>
                            <FormattedMessage id="ok" defaultMessage="Ok"></FormattedMessage>
                        </ModalButton>
                    </ModalFooter>
                </Modal>
            }
        </>
    )
}

export default DeleteEnergyRateButton;